<template>
  <div class="welcome">
  
    <div class="register-text">
      <h3>
        {{ $t("welcome.header") }}
      </h3>
      <p class="textbox" v-html="$t('welcome.description')"></p>
    </div>
    <div class="button-container">
      <GoogleButton />
      <div class="registratio-disclaimer-text">
        ההרשמה למערכת מהווה אישור לקריאה והסכמה ל<span @click="navigate('terms')">תנאי השימוש</span> ול<span
          @click="navigate('privacy')">מדיניות הפרטיות</span> שלנו.
      </div>
    </div>
  </div>
</template>

<script>
import GoogleButton from "../User/googleButton.vue";
import "../Shared/style.scss";

export default {
  methods: {
    goBack() {
      this.$router.push('/');
    },
    navigate(path) {
      this.$router.push(`/${path}`);
    },
    goToWA() {
      window.open(
        "https://api.whatsapp.com/send?phone=972526252650&text=%D7%94%D7%99%D7%99!%20%F0%9F%98%83%0A%D7%90%D7%A0%D7%99%20%D7%A8%D7%9B%D7%A9%D7%AA%D7%99%20%D7%9E%D7%A0%D7%95%D7%99%20%D7%9C%D7%90%D7%A4%D7%9C%D7%99%D7%A7%D7%A6%D7%99%D7%94%20%D7%A9%D7%9C%D7%9A%20%D7%9B%D7%91%D7%A8%20%D7%95%D7%92%D7%9D%20%D7%99%D7%A9%20%D7%9C%D7%99%20%D7%A7%D7%91%D7%9C%D7%94%20%D7%90%D7%91%D7%9C%20%D7%96%D7%94%20%D7%93%D7%95%D7%A8%D7%A9%20%D7%9E%D7%9E%D7%A0%D7%99%20%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%2C%20%D7%AA%D7%95%D7%9B%D7%9C%20%D7%9C%D7%A2%D7%96%D7%95%D7%A8%20%D7%9C%D7%99%20%D7%9C%D7%A9%D7%97%D7%96%D7%A8%20%D7%90%D7%AA%20%D7%94%D7%9E%D7%A0%D7%95%D7%99%20%D7%A9%D7%9C%D7%99%3F%0A%D7%AA%D7%95%D7%93%D7%94",
        "_blank"
      );
    }
  },
  components: {
    GoogleButton
  }
};
</script>

<style scoped>
.footerLinks {
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-top: 0;
  width: calc(100vw - 40px);
  position: fixed;
  bottom: 0;
  height: max-content;
}

.textbox {
  font: var(--medium-font);
  color: var(--color-primary-lt);
  margin-top: 16px;
}

.button-container {
  width: 100%;
  margin-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.registratio-disclaimer-text,
.registratio-disclaimer-text span {
  font: var(--tiny-font);
  padding: 8px;
  text-align: center;
  color: var(--color-secondary-ltr);
}

.registratio-disclaimer-text span {
  text-decoration: underline;
  padding: 0;
}
.welcome {    display: flex;
    justify-content: center;}
    .register-text{margin-bottom:0;}
    .textbox{margin:0;}
</style>


// WEBPACK FOOTER //
// welcome.vue?67d9f770